export interface ISubscription {
  id: string;
  name: string;
  durationType: SubscriptionDurationTypesEnum;
  duration: number;
  isVisible: boolean;
  credits: number;
  creditsRolloverAmount: number;
  price: number;
  description: string;
}

export type ISubscriptionUpdateModel = Omit<
  ISubscription,
  "id" | "durationType" | "duration" | "price"
>;

export enum UserSubscriptionStatusEnum {
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  trialing = "trialing",
  active = "active",
  past_due = "past_due",
  canceled = "canceled",
  unpaid = "unpaid",
  paused = "paused",
}

export enum SubscriptionDurationTypesEnum {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}

// Stripe allows recurring intervals of at most 3 years (3 years, 36 months, 156 weeks)
export const MAX_SUBSCRIPTION_DURATION: Record<SubscriptionDurationTypesEnum, number> = {
  [SubscriptionDurationTypesEnum.day]: 1095,
  [SubscriptionDurationTypesEnum.week]: 156,
  [SubscriptionDurationTypesEnum.month]: 36,
  [SubscriptionDurationTypesEnum.year]: 3,
};
